<template>
    <div>
        <b-card :title="title">
            <b-tabs card>
                <b-tab title="Asset" active>
                    <b-card-body>
                        <b-form @submit.stop.prevent="onSubmit">
                            <b-form-row align-h="center">
                                <b-col
                                    v-for="(d_item, i) in formFields"
                                    :key="i + 'data'"
                                    cols="6"
                                >
                                    <b-form-group
                                        :id="d_item.field"
                                        :label="
                                            d_item.label ||
                                            getLabel(d_item.field, true)
                                        "
                                        :label-for="'input-' + d_item.field"
                                        label-class="font-weight-bold pt-0"
                                    >
                                        <location-section
                                            ref="locationSection"
                                            v-model="model.location_section_id"
                                            @update-section-model="
                                                x => (locationData = x)
                                            "
                                            :hide-controls="true"
                                            :disabled="isView"
                                            v-if="
                                                d_item.field ==
                                                'location_section_id'
                                            "
                                            title=""
                                            modal-title="Asset Location"
                                            :is-modal="true"
                                        >
                                            <template
                                                #default="{
                                                    setSearchMode,
                                                    hideModal,
                                                }"
                                            >
                                                <b-button
                                                    v-show="!isView"
                                                    @click="setSearchMode()"
                                                    v-if="hasPermissionUpdate"
                                                    variant="secondary"
                                                    >Change Location</b-button
                                                >
                                                <b-button
                                                    class="mr-2"
                                                    variant="warning"
                                                    @click="hideModal()"
                                                    >Cancel</b-button
                                                >

                                                <b-button
                                                    class="mr-2"
                                                    variant="primary"
                                                    :disabled="loading"
                                                    v-show="hasPermissionView"
                                                    @click="isView = !isView"
                                                    >{{
                                                        isView ? 'Edit' : 'View'
                                                    }}</b-button
                                                >
                                            </template>
                                        </location-section>

                                        <select-order-template
                                            v-else-if="
                                                d_item.type === 'custom' &&
                                                d_item.field ==
                                                    'order_template_id'
                                            "
                                            v-model="model[d_item.field]"
                                            :toggle-active="true"
                                            :disabled="isView"
                                            include-order-type
                                        />
                                        <customer-type-ahead
                                            v-else-if="
                                                d_item.type === 'custom' &&
                                                d_item.field == 'customer_id'
                                            "
                                            :key="locationRefreshCounter"
                                            v-model="model[d_item.field]"
                                            :disabled="isView"
                                        />

                                        <b-form-select
                                            v-else-if="d_item.type === 'select'"
                                            :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]"
                                            :required="d_item.required"
                                            :options="getOptions(d_item.field)"
                                            :disabled="isView"
                                        >
                                            <template #first>
                                                <b-form-select-option
                                                    :value="null"
                                                    disabled
                                                    >{{
                                                        'Select ' +
                                                        getLabel(d_item.field)
                                                    }}</b-form-select-option
                                                >
                                            </template>
                                        </b-form-select>

                                        <link-modal
                                            v-else-if="d_item.type === 'url'"
                                            v-model="model[d_item.field]"
                                            :key="model[d_item.field]"
                                            :disabled="isView"
                                        ></link-modal>

                                        <b-form-input
                                            :disabled="isView"
                                            v-else
                                            :type="d_item.type"
                                            :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]"
                                            :required="d_item.required"
                                            :placeholder="
                                                'Enter ' +
                                                getLabel(d_item.field)
                                            "
                                            trim
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>

                            <b-form-row>
                                <b-col>
                                    <b-button-group size="sm">
                                        <b-button
                                            variant="secondary"
                                            :disabled="!!loading"
                                            @click="$router.go(-1)"
                                            >Cancel</b-button
                                        >
                                        <b-button
                                            v-if="this.model.id"
                                            v-show="hasPermissionDelete"
                                            @click="deleteAsset()"
                                            variant="warning"
                                        >
                                            Delete Asset
                                        </b-button>
                                        <b-button
                                            v-if="!!model.id"
                                            variant="primary"
                                            :disabled="loading"
                                            v-show="hasPermissionView"
                                            @click="isView = !isView"
                                            >{{
                                                isView ? 'Edit' : 'View'
                                            }}</b-button
                                        >
                                        <b-button
                                            variant="primary"
                                            :disabled="loading"
                                            type="submit"
                                            v-if="!isView"
                                        >
                                            <b-spinner
                                                v-show="loading"
                                                label="Spinning"
                                                v-if="hasPermissionUpdate"
                                            ></b-spinner>
                                            {{ model.id ? 'Update' : 'Create' }}
                                        </b-button>
                                    </b-button-group>
                                </b-col>
                            </b-form-row>
                        </b-form>
                    </b-card-body>
                </b-tab>
                <b-tab title="Master Items" :disabled="!isView">
                    <b-card-body>
                        <b-table
                            responsive
                            :items="masterItems"
                            :fields="master_fields"
                        >
                            <template #cell(id)="row">
                                <b-button
                                    size="sm"
                                    :to="`/admin/master-items/${row.item.id}`"
                                    class="mr-2"
                                    variant="primary"
                                    v-if="hasPermissionView"
                                >
                                    View
                                </b-button>
                            </template>
                        </b-table>
                    </b-card-body>
                </b-tab>
                <b-tab title="Service History" :disabled="!isView">
                    <b-card-body>
                        <b-table
                            responsive
                            :items="services"
                            :fields="service_fields"
                        >
                            <template #cell(order_id)="row">
                                <b-button
                                    size="sm"
                                    :to="`/admin/orders/${row.item.order_id}`"
                                    class="mr-2"
                                    variant="primary"
                                    v-if="hasPermissionView"
                                >
                                    View Order
                                </b-button>
                            </template>
                        </b-table>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>
<script>
import CustomerTypeAhead from '@/components/CustomerTypeAhead'

import SelectOrderTemplate from '@/components/SelectOrderTemplate'

import assetMixins from '@/mixins/assetMixins'
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'

import permissionsMixins from '@/mixins/permissionsMixins'

import LocationSection from '@/views/Location/LocationSection'
import LinkModal from '@/components//LinkModal'

const dataItems = [
    //mandatory  but must be automated
    { field: 'name', type: 'text', required: true },
    { field: 'type_id', type: 'select', required: true },

    //optional that will be ignored
    { field: 'serial_no', type: 'text' },
    { field: 'model_no', type: 'text' },
    { field: 'description', type: 'text' },

    { field: 'manufacturer_id', type: 'select', required: true },

    { field: 'customer_id', type: 'custom', required: true },
    { field: 'location_section_id', type: 'custom', required: true },

    { field: 'vendor_id', type: 'select', required: true },
    { field: 'notes', type: 'text' },
    { field: 'manual_url', type: 'url' },
    { field: 'service_plan_url', type: 'url' },
    { field: 'image_url', type: 'url' },
    { field: 'warranty_expiry_date', type: 'date' },
    { field: 'last_service_date', type: 'date' },
    { field: 'next_service_date', type: 'date' },
    { field: 'frequency', type: 'select', required: true },

    ///////////  new fields
    { field: 'service_week_day', type: 'select', required: false },
    { field: 'service_time_of_day', type: 'time', required: false },
    { field: 'contract_expiry_date', type: 'date', required: false },
    { field: 'default_engineer_id', type: 'select', required: false },
    { field: 'order_template_id', type: 'custom', required: false },
]

const crm_fields = [
    { field: 'customer_id', label: 'Customer' },
    { field: 'location_section_id', label: 'Agent Address' },
    //// { field:'last_service_date',label:""},
    { field: 'next_service_date', label: 'Next Visit' },
    { field: 'service_week_day', label: 'Week Day' },
    { field: 'service_time_of_day', label: 'Time of Day' },
    { field: 'frequency', label: 'Frequency' },
    { field: 'default_engineer_id', label: 'Sales Agent' },
]

const generateEmptyForm = () => {
    return dataItems.reduce(
        (_form, item) => {
            _form[item.field] = null
            return _form
        },
        { id: 0 }
    )
}

const model = generateEmptyForm()
export default {
    name: 'assets-ViewItem',

    components: {
        LocationSection,
        LinkModal,
        CustomerTypeAhead,
        SelectOrderTemplate,
    },
    mixins: [popupMixins, assetMixins, utilityMixins, permissionsMixins],
    data() {
        return {
            crm: false,
            crm_fields,
            locationData: {},
            newMasterItem: null,
            isError: false,
            locationRefreshCounter: 0,
            locationState: false,
            dataItems,
            model,
            loading: false,
            hasErrors: false,
            isView: false,
            uploadModal: false,
            master_fields: [
                {
                    key: 'id',
                    label: '',
                },
                'name',
                'description',
                {
                    key: 'order_item_type_id',
                    label: 'Type',
                    formatter: (value, key, item) => {
                        item = item || {}
                        const type = item.type || {}
                        return type.name
                    },
                },
            ],
            service_fields: [
                'name',
                {
                    key: 'order_item_type_id',
                    label: 'type',
                    formatter: (value, key, item) => item.item_type.name,
                },
                {
                    key: 'order.created_at',
                    label: 'Created',
                    formatter: (value, key, item) =>
                        new Date(item.order.created_at)
                            .toISOString()
                            .split('T')[0],
                },

                {
                    key: 'order_id',
                    label: '',
                },
            ],
        }
    },
    props: ['id'],

    computed: {
        formFields() {
            const { crm, dataItems } = this
            if (crm) {
                return crm_fields.map(x => {
                    const dataField = dataItems.find(y => y.field == x.field)
                    return { ...x, ...dataField }
                })
            } else {
                return this.dataItems
            }
        },
        crmSettingValue() {
            const crmSettingValue =
                this.$store.getters['company/crmSettingValue']
            console.log('computed  crmSettingValue', crmSettingValue)
            return crmSettingValue
        },
        crmsettingsKey() {
            return this.$store.state.company.settingKeys.crmsettingsKey
        },

        manditory_fields() {
            return [
                'name',
                'type_id',
                'vendor_id',
                'manufacturer_id',
                'location_section_id',
            ]
        },
        masterItems() {
            const asset = this.asset || {}
            let master_items =
                (asset.order_template && asset.order_template.items) || []
            return master_items.map(x => x.master_item)
        },
        asset() {
            const asset = this.$store.state.assets.asset || {}
            console.log('asset', asset)
            return asset
        },
        services() {
            return (this.asset.services || []).map(x => x.item)
        },

        title() {
            return this.model.id
                ? 'Edit Asset'
                : this.crm
                ? 'Create CRM'
                : 'Create New Asset'
        },
        types() {
            return this.$store.state.assets.types
        },
        vendors() {
            return this.$store.state.assets.vendors
        },

        customers() {
            return this.$store.state.customers.items
        },

        locations() {
            return this.$store.state.locations.locations
        },
        engineers() {
            return this.$store.state.users.all_users.map(x => ({
                id: x.id,
                name: `${x.first_name} ${x.last_name}`,
            }))
        },
        orderTypes() {
            return this.$store.state.orderType.items
        },
    },
    watch: {
        'model.customer_id': function (customer_id) {
            console.log('customer_id', customer_id)
            const customer = this.customers.find(x => x.id === customer_id)
            if (customer && customer.location_section_id) {
                console.log('customer', customer)
                this.model.location_section_id = customer.location_section_id
                this.locationRefreshCounter++
            }
        },
        'model.location_section_id': function (val) {
            console.log('watch asset.location_section_id', val)
        },
        crmSettingValue: {
            handler: function (val) {
                console.log('crm setting val', val)
            },
            deep: true,
        },

        services: function (val) {
            console.log('serfvices:--', val)
        },
        locationData: {
            handler: function (to, from) {
                if (!from) return
                for (const key in to) {
                    this.$set(this.model, key, to[key])
                }
            },
            deep: true,
        },
    },
    created() {
        this.$store.dispatch('users/fetchAll')
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('js_report/fetchCredentials')
    },
    async mounted() {
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.crmsettingsKey
        )
        const { id } = this
        console.log('id', id)
        this.model = generateEmptyForm()
        if (id) {
            await this.loadAsset(id)
        }
        this.crm = !!this.$route.query.crm
        console.log('crm', this.crm)
    },
    methods: {
        IntToTimeFormat(intValue) {
            const formatInt = _int => {
                if (_int < 10) _int = `0${_int}`
                else _int = _int.toString()
                return _int
            }
            let hours = parseInt(intValue / 60, 10)
            if (hours > 23 || hours < 0) hours = 0
            let minutes = intValue - hours * 60

            return `${formatInt(hours)}:${formatInt(minutes)}`
        },
        TimeFormatToInteger(_time) {
            try {
                const [hours, minutes] = _time.split(':')
                return parseInt(hours) * 60 + parseInt(minutes)
            } catch (err) {
                return null
            }
        },

        async loadAsset(id) {
            this.loading = true
            this.isView = true
            try {
                await this.$store.dispatch('assets/get', id)
                await this.$nextTick()
                for (let key of Object.keys(this.asset)) {
                    let value = this.asset[key]
                    if (key === 'service_time_of_day') {
                        value = this.IntToTimeFormat(value)
                    }
                    this.$set(this.model, key, value)
                }

                let { locationData } = this
                locationData = locationData || {}
                for (const key in locationData) {
                    this.$set(this.model, key, locationData[key])
                }
            } catch (error) {
                console.error(error)
                this.isError = true
            } finally {
                this.loading = false
            }
        },

        async onSubmit() {
            this.loading = true

            try {
                console.log('starting now')
                if (this.crm) {
                    const { type_id, vendor_id } = this.crmSettingValue
                    this.$set(this.model, 'type_id', type_id)
                    this.$set(this.model, 'vendor_id', vendor_id)
                    this.$set(this.model, 'manufacturer_id', vendor_id)
                    this.$set(
                        this.model,
                        'name',
                        (Math.random() + 1).toString(36).substring(7)
                    )
                }
                const valid = await this.$validator.validate()
                if (!valid) throw new Error('Invalid Entry')

                console.log('valid so far')

                console.log('model', this.model)
                const payload = {
                    ...this.model,
                }
                payload.service_time_of_day = this.TimeFormatToInteger(
                    payload.service_time_of_day
                )
                /*  if (!payload.location_section_id)
                    throw new Error(`Asset Location Not Selected!`) */
                console.log('payload', payload)
                const id = parseInt(payload.id) || null
                delete payload.id
                const path = `assets/${id ? 'update' : 'create'}`
                console.log('submit payload', payload)
                console.log('submit path', path)
                await this.$store.dispatch(path, { id, payload })
                this.model = generateEmptyForm()
                //this.$emit('success', `Item ${id ? 'Updated' : 'Created'}`)
                this.doToast('Asset', 'Asset Updated', 'success')
                this.$router.push({ name: 'assets' })
            } catch (error) {
                this.doToast('Error Detected', error.message, 'warning')
            } finally {
                this.loading = false
            }
        },
        deleteAsset() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/admin/assets',
                deleteRoute: 'assets/delete',
            }
            const notificationFields = {
                type: 'Asset',
                errorMsg: 'Unable to delete asset!',
            }

            this.deleteItem(notificationFields, model, routes)
        },

        setAssetLocation({ section, location }) {
            console.log('setAssetLocation-evt', { section, location })
            const { name: section_name } = section
            location = location || section.location || {}
            this.$set(this.model, 'section_name', section_name)
            this.$set(this.model, 'location', location)
        },
    },
}
</script>
<style></style>
